import { Box, Tab, Tabs } from "components";
import { useState } from "react";
import {
  useGetOrderBatchesQuery,
  useGetSystematicPlansQuery,
} from "store/features/MFOrders";
import CreateOrderButton, { CreateOrderType } from "./CreateOrderButton";
import OrdersListTable from "./OrdersListTable";
import SideModal from "./SideModal";
import SystematicPlansTable from "./SystematicPlansTable";
import useGenerateQueryParams from "hooks/useGenerateQueryParams";

// const EmptyState = ({
//   onSelect,
// }: {
//   onSelect: (orderType: CreateOrderType) => void;
// }) => (
//   <Grid2
//     container
//     justifyContent="center"
//     alignItems="center"
//     sx={{ height: "100%" }}
//   >
//     <Box
//       sx={{
//         alignItems: "center",
//         display: "flex",
//         flexDirection: "column",
//         gap: "24px",
//         width: 372,
//       }}
//     >
//       <Box
//         sx={{
//           alignItems: "center",
//           display: "flex",
//           height: 100,
//           justifyContent: "center",
//           width: 100,
//         }}
//       >
//         <OrderIcon height={92} width={88} color="var(--neutral-100)" />
//       </Box>

//       <Box
//         sx={{
//           alignItems: "center",
//           display: "flex",
//           flexDirection: "column",
//           gap: "4px",
//           textAlign: "center",
//           width: "100%",
//         }}
//       >
//         <Typography
//           fontSize={16}
//           fontWeight={600}
//           color="var(--grey-900)"
//           lineHeight="normal"
//         >
//           No orders yet
//         </Typography>
//         <Typography
//           fontSize={14}
//           fontWeight={400}
//           color="var(--neutral-700)"
//           lineHeight={1.5}
//         >
//           Place your first mutual fund or equity order to manage and track all
//           orders in one spot.
//         </Typography>
//       </Box>

//       <CreateOrderButton onSelect={onSelect} />
//     </Box>
//   </Grid2>
// );

const TABS = ["All Orders", "Systematic Plans"] as const;

const EmptyScreen = () => {
  const [sideModal, setSideModal] = useState<{
    open: boolean;
    orderType: CreateOrderType | null;
  }>({
    open: false,
    orderType: null,
  });
  const [activeTab, setActiveTab] = useState(0);

  const requestBody = useGenerateQueryParams("mfOrderBatches");
  const { data, isFetching } = useGetOrderBatchesQuery(requestBody);
  const orders = data?.data ?? [];

  const { data: plansData, isFetching: isPlansFetching } =
    useGetSystematicPlansQuery(undefined, { skip: activeTab !== 1 });
  const plans = plansData?.data ?? [];

  const handleOpenSideModal = (orderType: CreateOrderType) => {
    setSideModal({ open: true, orderType });
  };

  const handleCloseSideModal = () => {
    setSideModal({ open: false, orderType: null });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <Box
        sx={{
          alignItems: "center",
          borderBottom: "1px solid var(--neutral-100)",
          display: "flex",
          justifyContent: "space-between",
          pr: "8px",
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(_e, val) => setActiveTab(val)}
          variant="standard"
        >
          {TABS.map((label, idx) => (
            <Tab key={label} label={label} value={idx} disableRipple />
          ))}
        </Tabs>
        <CreateOrderButton onSelect={handleOpenSideModal} variant="compact" />
      </Box>
      {activeTab === 0 ? (
        <OrdersListTable
          orders={orders}
          loading={isFetching}
          count={data?.totalCount || 0}
        />
      ) : (
        <SystematicPlansTable plans={plans} loading={isPlansFetching} />
      )}

      <SideModal
        open={sideModal.open}
        orderType={sideModal.orderType}
        onClose={handleCloseSideModal}
      />
    </Box>
    // <>
    //   {hasOrders ? (
    //   ) : (
    //     <EmptyState onSelect={handleOpenSideModal} />
    //   )}

    //   <SideModal
    //     open={sideModal.open}
    //     orderType={sideModal.orderType}
    //     onClose={handleCloseSideModal}
    //   />
    // </>
  );
};

export default EmptyScreen;
